Flup.service("carousel", function(flup) {

    this.setup = function($elm) {
		var defaultOpts = {
			nav: true
		};

		var data = $elm.data();
		var opts = $.extend({}, defaultOpts, {
			stagePadding: data["stage-padding"],
            center: data["center"],
            loop: data["loop"],
			margin: data["margin"],
			items: data["items"],
            nav: data["nav"],
            navClass: data["nav-class-prev"] ? [data["nav-class-prev"], data["nav-class-next"]] : undefined,
            dots: data["dots"],
            merge: data["merge"],
            lazyload: data["lazyload"],
            autoplay: data["autoplay"],
            autoplayTimeout: data["autoplay-timeout"],
            responsive: data["responsive"]||{},
		});
		
		for(var x in data){
			if(x.indexOf("items-") === 0){
				var k = x.split("-")[1];
				opts.responsive[k] = $.extend({}, opts.responsive[k] || {}, {items: data[x]});
			}
			else if(x.indexOf("responsive-") === 0){
				var k = x.split("-")[1];
				opts.responsive[k] = $.extend({}, opts.responsive[k] || {}, JSON.parse(data[x])||{});
			}
		}

		opts.slideBy = opts.slideBy||opts.items;
		for(var y in opts.responsive){
			opts.responsive[y].slideBy = opts.responsive[y].slideBy||opts.responsive[y].items;
		}

        $elm.owlCarousel(opts);
    }
});

Flup.link("carousel", function(flup, $elm, value) {
    flup("carousel").setup($elm);
});